import { Injectable } from '@angular/core';
import { environment } from "../environments/environment";
import { Http, Headers, Response } from "@angular/http";
import { AuthHttp } from 'angular2-jwt';
import { Observable } from "rxjs/Observable"
import "rxjs/add/operator/map";

declare var $: any;


@Injectable()
export class MapBonusTemplateApiService {

  constructor(
    private http: Http,
    private authHttp: AuthHttp
  ) { }

  GetMaps() {
    return this.authHttp.get(environment.apiEndPoint + '/mapbonustemplate/maps').map((response: Response) => response.json());
  }

  GetMapBonusTemplate(year) {
    return this.authHttp.get(environment.apiEndPoint + '/mapbonustemplate/maps/' + year).map((response: Response) => response.json());
  }

  EditDueDate(dueDate, mapID) {
    var formData = new FormData();
    formData.append("modifiedDueDate", dueDate);
    formData.append("mapBonusTemplateID", mapID);

    return this.authHttp.post(environment.apiEndPoint + '/mapbonustemplate/maps/duedate', formData).map((response: Response) => response.json());
  }

  EditTemplate(quarter, year, templateID) {
    var formData = new FormData();
    formData.append("quarter", quarter);
    formData.append("year", year);
    formData.append("templateID", templateID);

    return this.authHttp.post(environment.apiEndPoint + '/mapbonustemplate/maps/template', formData).map((response: Response) => response.json());
  }

  SendEmail(mapID) {
    return this.authHttp.post(environment.apiEndPoint + '/mapbonustemplate/email/' + mapID, new FormData()).map((response: Response) => response.json());
  }

  SendEmailBlast(year) {
    return this.authHttp.post(environment.apiEndPoint + '/mapbonustemplate/blastemail/' + year, new FormData()).map((response: Response) => response.json());

  }
}



// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/data/MapBonusTemplateApi.service.ts